import { useDataFieldSection } from '~/hooks/useDataFieldSection';
import { AllDataFields } from '~/types/DataFieldSection';

interface Options {
  allDataFields: AllDataFields;
  isLoading: boolean;
}

export function withGetDataFieldSections(
  WrappedComponent: React.ComponentType<Options>,
) {
  function FieldSetionsDataContainer({ ...rest }) {
    const { isFetching, allDataFields } = useDataFieldSection();
    return (
      <WrappedComponent
        {...rest}
        isLoading={isFetching}
        allDataFields={allDataFields}
      />
    );
  }

  return FieldSetionsDataContainer;
}
